import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
const {NODE_ENV} = process.env
// console.log(NODE_ENV)
// create an axios instance
const service = axios.create({
  baseURL: NODE_ENV=='"development"'?'/api':process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL: '/api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 1000) {

      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      }
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service
